var _ellipse, _path, _path2, _circle, _circle2, _path3, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSadCar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 104,
  height: 104,
  fill: "none",
  viewBox: "0 0 104 104"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 54.699,
  cy: 24.794,
  stroke: "#00AED9",
  strokeWidth: 2,
  rx: 12,
  ry: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M62.699 76.794c-1.312-2.377-3.954-4-7-4s-5.688 1.623-7 4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M62.199 61.794h-14.5m-12 0H23.555a.856.856 0 0 1-.856-.856v-3.145m0 0h-12m12 0v-2m-9-3.938h9v-2.662a1 1 0 0 1 .847-.989l10.797-1.669a.86.86 0 0 0 .403-.176l2.607-2.08.696-.555m36.65 18.07h13.144a.856.856 0 0 0 .856-.856V53.55c0-.747-.485-1.408-1.198-1.633l-11.212-3.53a.9.9 0 0 1-.297-.164L63.956 37.997a.86.86 0 0 0-.555-.203H45.98a.86.86 0 0 0-.508.166l-2.55 1.877-1.173.806a.86.86 0 0 1-.484.15H30.699"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 41.726,
  cy: 62.794,
  r: 6,
  stroke: "#00619E",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 68.699,
  cy: 62.794,
  r: 6,
  stroke: "#00619E",
  strokeWidth: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M9.699 51.794h-3M26.699 40.794h-6"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 41.699,
  cy: 62.794,
  r: 2,
  stroke: "#00619E",
  strokeWidth: 2
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 68.699,
  cy: 62.794,
  r: 2,
  stroke: "#00619E",
  strokeWidth: 2
})));
export default SvgSadCar;